import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "normalize.css"; // 重置样式表
import "@/assets/styles/common.scss";
import "@/assets/styles/moduls.scss";
import globalDataMixin from "@/mixins/globalDataMixin.js";
import componentProperties from "@/utils/componentProperties"; // 组件数据
Vue.prototype.$componentProperties = componentProperties;
// 全局注入 上传组件的url
Vue.prototype.$uploadUrl = "http://192.168.3.3:8070/oss/upload";
// Vue.prototype.$uploadUrl = "http://192.168.3.194:5050/api/v1/upload/image";
// 全局混入
Vue.mixin(globalDataMixin);
// 全局注册vue-json-viewer
import VueJsonViewer from "vue-json-viewer";
Vue.component("vue-json-viewer", VueJsonViewer);
// 注册公共拖拽组件
import VueDraggable from "vuedraggable";
Vue.component("vuedraggable", VueDraggable);
import plugins from "../plugins"; // plugins
Vue.use(plugins); // 挂载 plugins 插件



// 封装全局方法：检查是否包含 page_home
Vue.prototype.$hasPageHome = function () {
  // 核心逻辑：遍历 pages 数组，判断是否有 pageId 为 page_home 的项
  const pages = this.$store.state.modules.templateData.pages || []; // 兼容 pages 为空的情况
  return pages.some((item) => item?.pageId === "page_home"); // ?. 防止 item 为 undefined
};
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css"; // 必须引入样式文件
Vue.use(Viewer);
Viewer.setDefaults({
  zIndex: 9999,
  toolbar: true,
  navbar: true,
  loop: true,
});
// 全局注册 v-viewer
// Vue.use(Viewer, {
//   defaultOptions: {
//     // 全局默认配置（可选）
//     zIndex: 9999,
//     inline: false,
//     button: true,
//     navbar: true,
//     title: true,
//     toolbar: true,
//     tooltip: true,
//     movable: true,
//     zoomable: true,
//     rotatable: true,
//     scalable: true,
//     transition: true,
//     fullscreen: true,
//     keyboard: true,
//     url: 'data-source'
//   }
// })
//全局挂载UUID
// 引入 uuid 库（v8 支持 CommonJS，直接 require）
const { v4: uuidv4 } = require("uuid");
// 全局挂载 UUID 生成方法（v4 是最常用的随机 UUID）
Vue.prototype.$uuid = uuidv4;
// 挂载公共的工具函数
import utils from "./utils/index";
Vue.prototype.$utils = utils;
import modals from "./utils/modal.js";
Vue.prototype.$modal = modals;

// 挂载全局工具函数方法
import toolUtils from "./utils/utils.js";
Vue.prototype.$toolUtils = toolUtils;
// 挂载全局服务器图片路径
Vue.prototype.$serverImgUrl =
  "https://lingxin1314.oss-cn-beijing.aliyuncs.com/weixiaozhu/";
// 挂载全局图片路径配置
import imagePath from "./utils/imagePath.js";
Vue.prototype.$imagePath = imagePath;
// 全局挂载二维码生成组件
// 引入二维码生成组件
import QrcodeGenerator from "@/components/public/QrcodeGenerrator.vue";
Vue.component("QrcodeGenerator", QrcodeGenerator);
// 挂载全局的api
import api from "./api/index.js";
Vue.prototype.$api = api;
import VueClipBoard from "vue-clipboard2";
Vue.use(VueClipBoard);
import WujieVue from "wujie-vue2";
const { bus } = WujieVue;
Vue.prototype.$wujieBus = bus;
Vue.use(WujieVue);
/* 引入Vant */
import Vant from "vant";
import "vant/lib/index.css";
// 引入全局css变量
import "./assets/css/variables.css";
Vue.use(Vant);
// 引入富文本编辑器
import VueQuillEditor from "vue-quill-editor";
// 引入富文本编辑器的样式
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

// 全局注册富文本编辑器
Vue.use(VueQuillEditor, {
  // 可以在这里配置一些默认参数（可选）
  // 例如：toolbar: [['bold', 'italic', ['link', 'image']]]
});
// 挂载全局默认数据配置
import defaultData from "./utils/defaultData.js";
Vue.prototype.$defaultData = defaultData;
// 注册全局过滤器/时间戳转换日期
import globalFilter from "@/utils/filter";

Object.keys(globalFilter).forEach((key) => {
  Vue.filter(key, globalFilter[key]);
});

// 引入全局混入
import clickHandlerMixin from "./mixins/clickHandlerMixin";
Vue.mixin(clickHandlerMixin);

/**
 * 全局跳转链接方法：支持内部/外部链接跳转
 * @param {Object} item - 包含跳转配置的对象（需有more字段）
 */
Vue.prototype.$jumpLink = function (item) {
  // 边界校验：item或item.more为空时提示
  if (!item || !item.more) {
    this.$message.error("跳转配置异常，请检查参数");
    return;
  }
  console.log(
    "main文件中查看更多点击了",
    this.datas, // 注意：this.datas 是调用组件的变量，若需全局使用需调整（见下方说明）
    this.$store.state.modules.templateData
  );

  // 1. 内部链接跳转（httpType = 10）
  if (item.more.httpType === 10) {
    console.log("内部链接跳转了", item);
    // 校验内部链接必要参数
    if (item.more.pageId && item.more.http?.internalLink) {
      this.$router.push({
        path: "/productOpenwecartAfter/admin/Edit",
        query: {
          pageId: item.more.pageId,
        },
      });
    } else {
      this.$message.error("请先选择跳转页面");
    }
  }

  // 2. 外部链接跳转（httpType = 11）
  if (item.more.httpType === 11) {
    // 校验外部链接是否存在
    if (!item.more.http?.externalLink) {
      this.$message.error("外部链接不能为空");
      return;
    }
    // 处理链接格式（补全https://）
    let url = item.more.http.externalLink.trim();
    if (url && !/^https?:\/\//.test(url)) {
      url = "https://" + url;
    }
    // 打开外部链接
    window.open(url, "_blank");
  }
};
// 组件自动化全局注册
const requireComponent = require.context(
  // 其组件目录的相对路径
  "./components/components/",
  // 是否查询其子目录
  true,
  // 匹配基础组件文件名的正则表达式
  /\.vue$/
);
requireComponent.keys().forEach((fileName) => {
  // 获取组件配置
  const componentConfig = requireComponent(fileName);
  // 获取组件的默认导出
  const componentDefault = componentConfig.default;

  // 生成组件名称：优先使用组件中定义的name属性，如果没有则从文件名中提取
  let componentName = "";
  if (componentDefault && componentDefault.name) {
    componentName = componentDefault.name;
  } else {
    // 从文件名中提取组件名，移除路径和文件扩展名
    // 例如: './components/uploadCommodity/index.vue' -> 'uploadCommodity'
    componentName = fileName
      .replace(/^\.\/|\.vue$/g, "")
      .replace(/\/index$/, "")
      .replace(/\//g, "-")
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join("");
  }

  console.log("获取组件的配置", componentName, componentDefault);

  // 全局注册组件
  Vue.component(componentName, componentDefault);
});
// import { ChromePicker } from "vue-color";
// Vue.component('chrome-picker', ChromePicker)
// 引用第三方iconfont图标库
import "@/assets/icon/iconfont/iconfont.css";
import qs from "qs";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.prototype.$message = ElementUI.Message;
Vue.prototype.$qs = qs;
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  created() {
    // 应用启动时恢复登录状态
    this.$store.dispatch("user/restoreLoginState");
  },
});
